import "layouts/Home/Home.css";
import React from "react";
import {request} from "../../../api-client";
import Folder from "../../../assets/img/Letflow/folder.png";
import {TableButton, TableButtonsBuilder} from "../../../components/Letflow/Table";
import localization from "../../../config/localization"
import {Edit, Share, MoreVert} from "@material-ui/icons";
import {IconButton, MenuItem} from "@material-ui/core";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import Delete from "@material-ui/icons/Delete";
import moment from "moment";

class HomePlaylistGridItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: this.props.playlist.id,
      open: false
    }
  }

  buildButtons = (playlist) => {
    let builder = new TableButtonsBuilder();

    builder
      .withDelete(
        playlist.title,
        () => request.playlist.delete(playlist.id),
        closeState => {
          if (closeState === 'passed') {
            this.props.onDelete && this.props.onDelete(playlist.id)
          }
        }
      )
      .withOther(
      <TableButton
        title={localization.get('edit')}
        onClick={() => this.props.onEdit(playlist)}
      >
        <Edit/>
      </TableButton>
    )
      .withOther(
        <TableButton
          title={localization.get('edit')}
          onClick={() => this.props.onShare(playlist.id)}
        >
          <Share/>
        </TableButton>
      )

    return builder.build()
  };

  getDate = (date) => {
    let event = new Date(date);
    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return event.toLocaleDateString(localStorage.getItem("default_language") === "es" ? 'es-ES' : 'en-US' , options)
  }



  render = () => {

    const { playlist, onClick, onDelete, onEdit, onShare } = this.props;
    /*<div style={{position: "absolute", top: 10, right: 10, borderRadius: 50, backgroundColor: "rgba(255, 255, 255, 0.7)"}}>{this.buildButtons(playlist)}</div>*/
    return (
      <div
        onClick={onClick}
        style={{
        position: "relative",
        float: "left",
        width: "100%",
        padding: 10,
        cursor:"pointer",
      }}>
        <div style={{position: "relative", backgroundPosition: "center",backgroundRepeat: "no-repeat",float: "right", width: "100%", height: 185, backgroundImage: `url(${Folder})`}}/>
        <div className="playlist-info-data">
          <div>
            <h3 style={{margin: 0, fontSize: 18, textAlign: "left"}}>{playlist.title.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}</h3>
            <h4 style={{margin: 0, fontSize: 11, textAlign: "left"}}> {localization.get('last_update')} {moment(playlist.updated_at).format('DD/MM/YY')}</h4>
          </div>
          <div
            aria-describedby={playlist.id}
            ref={node => this.anchorEl = node}
            aria-owns={this.state.open ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              this.setState({open: !this.state.open})
            }}
          >
            <IconButton>
              <MoreVert />
            </IconButton>
          </div>
          <Popper
            open={this.state.open}
            id={playlist.id}
            anchorEl={this.anchorEl}
            transition
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            style={{zIndex:1400}}
          >
            {({TransitionProps, placement}) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{transformOrigin: "center right", zIndex:10}}
              >
                <Paper style={{zIndex:10}}>
                  <ClickAwayListener onClickAway={() => this.setState({open: false})}>
                    <MenuList
                      style={{paddingBottom: 0, paddingTop: 0, minWidth: 250,}}>
                      <MenuItem
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          onDelete(playlist.id)
                          this.setState({open: false})
                        }}
                        style={{ color: "#525252"}}>
                        <Delete />
                        <span style={{marginLeft: 5}}>{localization.get('delete')}</span>
                      </MenuItem>
                      <MenuItem
                        style={{ color: "#525252"}}
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          onEdit(playlist)
                          this.setState({open: false})
                        }}>
                        <Edit />
                        <span style={{marginLeft: 5}}>{localization.get('edit')}</span>
                      </MenuItem>
                      <MenuItem
                        style={{ color: "#525252"}}
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          onShare()
                          this.setState({open: false})
                        }}>
                        <Share />
                        <span style={{marginLeft: 5}}>{localization.get('share')}</span>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    )
  }
}
export default HomePlaylistGridItem
